module.exports = __webpack_public_path__ + "img/loading-sy.7b8b0fa5.gif";